module.exports = __webpack_public_path__ + "static/img/Soligo.5264ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Soligo.jpg
// module id = dTi6
// module chunks = 0